<template>
  <div class="photo-album-advanced__navigation">
    <button
      class="photo-album-advanced__button photo-album-advanced__button--prev"
      :class="{ 'photo-album-advanced__button--disabled': !canAdvanceBackward }"
      :aria-disabled="!canAdvanceBackward"
      :disabled="!canAdvanceBackward"
      @click.prevent="triggerPageAdvance('backward')"
    >
      <slot name="prev"></slot>
    </button>
    <button
      class="photo-album-advanced__button photo-album-advanced__button--next"
      :class="{ 'photo-album-advanced__button--disabled': !canAdvanceForward }"
      :aria-disabled="!canAdvanceForward"
      :disabled="!canAdvanceForward"
      @click.prevent="triggerPageAdvance('forward')"
    >
      <slot name="next"></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'photo-album-advanced-navigation',
  data() {
    return {
      carousel: this.$parent.$parent,
    };
  },
  computed: {
    canAdvanceForward() {
      let canAdvanceForward = false;

      if (this.carousel) {
        canAdvanceForward = this.carousel.canAdvanceForward;
      }

      return canAdvanceForward;
    },
    canAdvanceBackward() {
      let canAdvanceBackward = false;

      if (this.carousel) {
        canAdvanceBackward = this.carousel.canAdvanceBackward;
      }

      return canAdvanceBackward;
    },
  },
  methods: {
    triggerPageAdvance(direction) {
      if (!this.carousel) {
        return;
      }

      if (direction) {
        this.carousel.advancePage(direction, 'navigation');
      }
    },
  },
};
</script>
